import React from "react";

const EditSeasonFormWrapper = (props) => {
  const renderChildrenWithProps = React.Children.map(props?.children, (child, i) => {
    return React.cloneElement(child, {
      ...props,
    });
  });

  return <>{renderChildrenWithProps}</>;
};

export default EditSeasonFormWrapper;
